import * as React from 'react';
import classNames from 'classnames';
import { Icon } from '@kzui/core';
import './style.less';

const HoverTip: React.FC<{
    className?: string;
    msg: string
}> = ({ className = '', msg }) => {
    const clsPrefix = 'c-hovertip';
    const cls = classNames(clsPrefix, className);
    return (
        <div className={cls}>
            <div className={`${clsPrefix}--btn`}>
                <Icon className={`kz-e-question-new-1 ${clsPrefix}--icon`} />
            </div>
            <div className={`${clsPrefix}--content`}>
                <div className={`${clsPrefix}--triangle`} />
                <div className={`${clsPrefix}--box`}>
                    {msg}
                </div>
            </div>
        </div>
    );
};

export default HoverTip;
